<style scoped>
  li {
    padding: 1em;
    border: 0.2em solid transparent;
  }

  li.selected {
    border: 0.2em solid black;
  }
</style>
<template>
  <div class="find">
    <ul>
      <li v-for="(b, i) in bookmarks" v-bind:key="i" v-bind:class="{ selected: i == selected }">
        <a :href="b.url">{{ b.title }}</a>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: "Find",
  data: function() {
    return {
      selected: 0,
      bookmarks: []
    };
  },
  methods: {
    keyUp: function(e) {
      if (e.key == 'j') {
        this.selected = (this.selected + 1) % this.bookmarks.length;
      } else if (e.key == 'k') {
        this.selected = Math.max(0, this.selected - 1);
      } else if (e.key == 'g') {
        document.location.href = this.bookmarks[this.selected].url;
      }
    }
  },
  created() {
    let params = new URLSearchParams(window.location.search);
    fetch(this.$root.api + params.get('tags'), { headers: {
      authorization: 'Bearer ' + JSON.parse(window.localStorage.getItem('id_token')).t
    }})
    .then(r => r.json())
    .then(r => {
      this.bookmarks = r;
    })
  },
  mounted() {
    document.addEventListener('keyup', this.keyUp);
  }
}

</script>
